import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { useColumnasCfg } from './AtencionColumnasContext';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel,
  DropdownMenuSeparator, DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';

const VACIO = { ocultas: [], mostradas: [] };

// Columnas visibles de una tabla, las mismas para todos (las elige un administrador). Se guarda qué se ocultó
// y qué se agregó, así una columna nueva (p. ej. un grupo que aparece después) se ve según su valor por defecto.
export const useColumnas = (clave, columnas) => {
  const { cfg, puede, guardar: guardarCfg } = useColumnasCfg();
  const pref = { ...VACIO, ...(cfg.vista[clave] || {}) };
  const guardar = (v) => guardarCfg({ vista: { ...cfg.vista, [clave]: v } });
  const visible = (c) => c.fija || (c.defecto !== false ? !pref.ocultas.includes(c.key) : pref.mostradas.includes(c.key));
  const ver = (key) => { const c = columnas.find((x) => x.key === key); return c ? visible(c) : false; };
  const toggle = (c) => {
    const sacar = (l) => l.filter((k) => k !== c.key);
    if (visible(c)) guardar(c.defecto !== false ? { ...pref, ocultas: [...pref.ocultas, c.key] } : { ...pref, mostradas: sacar(pref.mostradas) });
    else guardar(c.defecto !== false ? { ...pref, ocultas: sacar(pref.ocultas) } : { ...pref, mostradas: [...pref.mostradas, c.key] });
  };
  return { ver, visible, toggle, puede, reset: () => guardar(VACIO) };
};

// Botón "Columnas" (solo administradores) para elegir qué columnas ven todos (al menos una además de las fijas).
export const ColumnasSelector = ({ columnas, estado, testId }) => {
  if (!estado.puede) return null;
  const elegibles = columnas.filter((c) => !c.fija);
  const quedan = elegibles.filter((c) => estado.visible(c)).length;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs" data-testid={testId}>
          <SlidersHorizontal className="h-3.5 w-3.5" /> Columnas
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-h-[60vh] w-60 overflow-auto">
        <DropdownMenuLabel>Columnas que ven todos</DropdownMenuLabel>
        <p className="px-2 pb-1 text-[11px] text-slate-400">Lo que elijas se guarda para todos los usuarios.</p>
        <DropdownMenuSeparator />
        {elegibles.map((c) => {
          const marcada = estado.visible(c);
          return (
            <DropdownMenuCheckboxItem key={c.key} checked={marcada} disabled={marcada && quedan === 1}
              onCheckedChange={() => estado.toggle(c)} onSelect={(e) => e.preventDefault()} data-testid={`${testId}-${c.key}`}>
              {c.label}
            </DropdownMenuCheckboxItem>
          );
        })}
        {quedan === 1 && <p className="px-2 py-1 text-[11px] text-slate-400">Tiene que quedar al menos una columna.</p>}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={(e) => { e.preventDefault(); estado.reset(); }} data-testid={`${testId}-defecto`}>
          Volver a las de siempre
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
